export function ensureHTMLElement(target: HTMLElement | null) {
  if (!target) throw new Error('SDK container element is required before mounting iframe')
  return target
}